// src/components/OrderList/constants.js

export const STATUS_OPTIONS = [
  "Очікує підтвердження",
  "Взято в роботу",
  "ТТН НП внесено",
  "Відправлено",
  "Доставлено",
  "Скасовано",
  "Повернення/обмін",
];

export const PAGE_SIZES = [10, 25, 50];

export const TTN_EDITABLE_STATUSES = new Set([
  "Взято в роботу",
  "ТТН НП внесено",
  "Відправлено",
  "Доставлено",
]);

export const TTN_REQUIRED_STATUSES = new Set([
  "ТТН НП внесено",
  "Відправлено",
  "Доставлено",
]);
